import consoleLogger from '../../../../modules/console-logger'
import isServerSide from '../../../../modules/is-server-side'

const updateExperiencePiano = () => {
  const [consoleLog] = consoleLogger('UpdateExperiencePiano')
  consoleLog('EXECUTE', 'ExperienceExecute')
  if (!isServerSide() && window.tp && window.tp.experience) {
    window.tp.experience.execute()
  }
}

export default updateExperiencePiano
